import { Link, SectionMessage, Text } from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { SettingsEditItem } from "../../../components/Settings/SettingsEditItem";
import { useUser } from "../../../hooks/api/useUser";

export function EmailSettings() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { user } = useUser();

  return (
    <SettingsEditItem
      setting={t("Email")}
      value={`${user ? user?.email : t("Not available")}`}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "email-cancel-link" : "email-update-link"}
      editText={t("Update")}
    >
      <SectionMessage
        type="info"
        sectionTitle={t("Need to update your email?")}
        icon="info"
      >
        <Text color="text-base">
          <Trans>Contact the Certn support team at</Trans>{" "}
          <Link
            testID="email-settings-support-link"
            textStyle="global/body-secondary"
            textColor="text-weak"
            href="mailto: support@certn.co"
            target="_blank"
          >
            <Text style="form/body-secondary-link" color="text-accent-tofino">
              support@certn.co
            </Text>
          </Link>{" "}
          <Trans>for assistance</Trans>
        </Text>
      </SectionMessage>
    </SettingsEditItem>
  );
}
